<template>
	<Layout>
		<template>
			<ValidationObserver ref="observer" v-slot="{ handleSubmit }">
				<form @submit.prevent="handleSubmit(updateProfile)">
					<article class="profile__column panel">
						<div class="panel__header">
							<span class="is-flex is-flex-direction-column is-justify-content-center">
								<h3 class="profile__name pt-0 is-semibold is-size-4">{{ $t('profile') }}</h3>
								<p class="is-size-6">{{ $t('update_personal') }}</p>
							</span>
							<b-button v-if="isDesktop" tabindex="6" native-type="submit" type="is-primary save" :loading="loading" rounded>{{ $t('save') }}</b-button>
						</div>
						<div class="panel__body">
							<h3 class="profile__section mb-5 has-text-primary is-semibold is-size-5">{{ $t('personal_data') }}</h3>
							<InputWithValidation class="profile__field" tab="1" rules="required" type="text" :label="$t('first_name')" size="is-medium" v-model="user.first_name" translate="no" />

							<InputWithValidation class="profile__field" tab="2" rules="required" type="text" :label="$t('last_name')" size="is-medium" v-model="user.last_name" />

							<InputWithValidation class="profile__field" tab="3" rules="required|email" type="email" label="E-mail" size="is-medium" v-model="user.email" />

							<InputWithValidation class="profile__field" tab="4" rules="required" type="date" :label="$t('birth_date')" size="is-medium" v-model="user.birth_date" />

							<div class="is-flex is-justify-content-flex-end mb-3">
								<b-button v-if="!isDesktop" tabindex="7" native-type="submit" type="is-primary save" :loading="loading" rounded>{{ $t('save') }}</b-button>
							</div>
						</div>
					</article>
				</form>
			</ValidationObserver>
		</template>
	</Layout>
</template>

<script>
import Layout from '@/layouts/Profile'
import InputWithValidation from '@/components/inputs/InputWithValidation'
import { ValidationObserver } from 'vee-validate'
import Api from '@/services/api'
import { mapState, mapActions } from 'vuex'
import { toast } from '@/mixins/toast'
import { responsive } from '@/mixins/responsive'

export default {
	name: 'Personal',
	mixins: [responsive],
	components: {
		Layout,
		InputWithValidation,
		ValidationObserver
	},
	data() {
		return {
			loading: false
		}
	},
	methods: {
		...mapActions('user', ['getUserData']),
		async updateProfile() {
			try {
				this.loading = true
				if (this.user.site) {
					const url = this.user.site.replace('http://', '').replace('https://', '')
					this.user = { ...this.user, site: `http://${url}` }
				}
				const response = await Api.put(`user/personal`, this.user)
				const { status } = response
				if (status === 200) {
					this.getUserData(true)
					toast('is-success', this.$t('profile_updated'))
				}
			} catch (e) {
				const { status } = e
				if (status === 500) {
					toast('is-danger', this.$t('profile_email_duplicated'))
				}
			} finally {
				this.loading = false
			}
		}
	},
	computed: {
		...mapState('user', ['user'])
	}
}
</script>
